import { Close, Delete } from "@mui/icons-material";
import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Drawer,
	FormLabel,
	IconButton,
	ImageList,
	ImageListItem,
	ImageListItemBar,
	TextField,
	Tooltip,
	Typography,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Create, UpdateGroup } from "../../apis/Group";
import { ScrapedEditProductDrawer } from "../../pages/UniverisalCart/components/Products/ScrapedEditProductDrawer";
import { showToast } from "../../utils/toast";
import { AddOptionPopover } from "../Form/AddOptionPopover";
import { CategoryAutocomplete } from "../Form/CatetoryAutoComplete";
import FormWrapper from "../Form/FormWrapper";
import { UploadSheetDrawer } from "./UploadSheetDrawer";

export const AddGroup = ({
	drawerOpen,
	setEditOpen,
	edit,
	setGroups,
	group,
	// New prop to handle universal cart
}) => {
	const {
		register,
		handleSubmit,
		setValue,
		reset,
		watch,

		formState: { errors },
	} = useForm({
		defaultValues: {
			name: "",
			description: "",
			qty_limit: 0,
			product_category: "",
		},
	});

	useEffect(() => {
		setProducts([]);
		reset({});
	}, [drawerOpen, reset]);

	const [category, setCategory] = useState(null);

	const [showCategory, setShowCategory] = useState(false);
	const [deletingProduct, setDeletingProduct] = useState(null);
	const [products, setProducts] = useState([]);
	const [addProduct, setAddProduct] = useState(false);
	const [sheetOpen, setSheetOpen] = useState(false);
	const values = watch();

	const [open, setOpen] = useState(false);

	const handleOpen = (item) => {
		setOpen(true);
		setDeletingProduct(item.id);
	};
	const handleClose = () => {
		setOpen(false);
		setDeletingProduct(null);
	};

	const onSubmit = async (data) => {
		console.log(data);
		data["products"] = products.map((g) => parseInt(g.id));
		if (data.product_category == null) {
			showToast("Please Select Group Category", "error");
			setShowCategory(true);
			return;
		}

		if (products.length === 0) {
			setAddProduct(true);
			showToast("Please select Products", "error");

			return;
		}
		console.log(data);
		let pproducts;
		if (Array.isArray(data["products"])) {
			pproducts = data["products"].map((p) => parseInt(p));
		} else {
			pproducts = parseInt(data["products"]);
		}
		const formData = new FormData();
		for (const i in data) {
			formData.append(i, data[i]);
		}

		formData["products"] = [pproducts];
		const res = edit
			? await UpdateGroup(formData, group.id)
			: await Create(formData);
		if (res.success) {
			console.log("====================================");
			console.log(res);
			console.log("====================================");
			setGroups((prev) =>
				edit
					? prev.map((g) => (g.id === group.id ? res : g))
					: [...prev, res],
			);
			setEditOpen(false);
		} else {
			showToast(res.error, "error");
		}
		// form= new FormData()
	};
	const setUniqueProducts = useCallback((products) => {
		const unique = Array.from(
			new Map(products.map((p) => [p.id, p])).values(),
		);
		console.log("====================================");
		console.log(unique);
		console.log("====================================");
		return unique;
	}, []);

	useEffect(() => {
		if (!group) {
			reset({}); // clear form
			setProducts([]);
			setCategory(null);
			return;
		}

		reset(group);
		setProducts((prev) => {
			const merged = [...prev, ...(group.products ?? [])];
			return setUniqueProducts(merged);
		});
		setCategory(group.product_category?.[0] ?? null);
	}, [group, reset, setUniqueProducts]);

	useEffect(() => {
		if (category) {
			setValue(
				"name",
				edit &&
					group?.name &&
					category?.id === group?.product_category?.[0]?.id
					? group.name
					: category?.name || "",
			);
			setValue("product_category", category?.id);
		}
	}, [category, edit, group?.name, group?.product_category, setValue]);
	const checkCategoryValid = () => {
		if (category == null) {
			showToast("Please Select Group Category", "error");
			setShowCategory(true);
			return false;
		}
		return true;
	};
	const handleAddProduct = () => {
		setAddProduct(checkCategoryValid());
	};

	const handleAddSheet = () => {
		setSheetOpen(checkCategoryValid());
	};

	// const handleURL = async (e) => {

	// 	setUrl(e.target.value);
	// 	if(e.target.value){
	// 	const data = await getProductPreview(e.target.value);
	// 	setProductPreview(data.data);
	// 	}
	// }

	return (
		<Drawer
			anchor="right"
			open={drawerOpen}
			onClose={() => setEditOpen(false)}
		>
			<Box
				sx={{
					width: addProduct ? 800 : 600,
					padding: 1,
					height: "100vh",
					overflowY: "scroll",
					scrollbarWidth: "none", // Firefox
					"&::-webkit-scrollbar": {
						display: "none", // Chrome, Safari, Edge
					},
				}}
			>
				<IconButton
					style={{ position: "fixed" }}
					onClick={() => setEditOpen(false)}
				>
					<Close />
				</IconButton>
				{/* <ToastContainer /> */}

				<FormWrapper onSubmit={handleSubmit(onSubmit)} sx={{ p: 5 }}>
					<Box display="flex" justifyContent="space-between">
						<Typography
							variant="h6"
							gutterBottom
						>{`Group`}</Typography>
						<Button
							type="submit"
							// onClick={handleSave}
							color="primary"
							variant="contained"
						>
							{edit ? "Update" : "Add"}
						</Button>
					</Box>
					<Box my={3}>
						<FormLabel>Group Category</FormLabel>
						<CategoryAutocomplete
							title="Group Category"
							showCategory={showCategory}
							setShowCategory={setShowCategory}
							category={category}
							setCategory={setCategory}
						/>
					</Box>

					<Box mb={3}>
						<TextField
							{...register("name", {
								required: "Enter group name",
							})}
							// key={watch("name") ?? "empty"}
							InputLabelProps={{ shrink: Boolean(watch("name")) }}
							fullWidth
							label="Name"
							variant="outlined"
							error={Boolean(errors.name)}
							helperText={errors.name?.message}
						/>
						<TextField
							{...register("product_category", {})}
							sx={{ display: "none" }}
							fullWidth
							variant="outlined"
						/>
					</Box>
					<Box my={3}>
						<TextField
							fullWidth
							name="description"
							multiline
							rows={4}
							// style={{ width: "100%" }}
							label="Enter description"
							variant="outlined"
							{...register("description", {
								required: "Enter description",
							})}
							error={Boolean(errors.description)}
							helperText={errors.description?.message}
						/>
					</Box>
					<Box mb={3}>
						<TextField
							fullWidth
							type="number"
							InputProps={{
								inputProps: { min: 0 },
							}}
							id="outlined-basic"
							label={"Qty Limit by Group"}
							variant="outlined"
							{...register("qty_limit", {
								required: "Enter qty limit",
							})}
							error={Boolean(errors.qty_limit)}
							helperText={errors.qty_limit?.message}
						/>
					</Box>

					<Box
						my={3}
						// display="flex"
						// justifyContent="right"
						// alignItems="right"
					>
						<Box display="flex" justifyContent="space-between">
							<Typography
								variant="h6"
								gutterBottom
							>{`Products`}</Typography>

							<AddOptionPopover label="Add products Via">
								<Button
									type="button"
									onClick={handleAddProduct}
									color="primary"
									variant="contained"
								>
									Pop up
								</Button>
								<Button
									type="button"
									onClick={handleAddSheet}
									color="primary"
									variant="contained"
								>
									Sheet
								</Button>
							</AddOptionPopover>
						</Box>
						{products && (
							<Box my={3}>
								<ImageList cols={3} gap={5}>
									{products.map((item, i) => (
										<ImageListItem
											key={`product-${item.id}`}
											sx={{
												"& .MuiImageListItem-img": {
													// height: 216,
													borderRadius: 1,
												},
											}}
										>
											<img
												srcSet={`${item?.image?.file}?w=248&fit=crop&auto=format&dpr=2 2x`}
												src={`${item?.image?.file}?w=248&fit=crop&auto=format`}
												alt={item?.name}
												loading="lazy"
												style={{ overflow: "hidden" }}
											/>
											<ImageListItemBar
												sx={{
													borderBottomRightRadius: 1,
													borderBottomLeftRadius: 1,
												}}
												title={
													<Tooltip
														title={item?.name}
														arrow
														placement="top"
														// sx={{"&."}}
														componentsProps={{
															tooltip: {
																sx: {
																	bgcolor:
																		"white",
																	color: "black",
																	boxShadow: 2,
																	fontSize: 14,
																},
															},
														}}
													>
														<span
															style={{
																overflow:
																	"hidden",
																textOverflow:
																	"ellipsis",
																whiteSpace:
																	"nowrap",
																display:
																	"block",
															}}
														>
															{item.name}
														</span>
													</Tooltip>
												}
												subtitle={item.author}
												actionIcon={
													<IconButton
														sx={{
															color: "rgb(255, 255, 255)",
														}}
														aria-label={`info about ${item.name}`}
														onClick={() =>
															handleOpen(item)
														}
													>
														<Delete />
													</IconButton>
												}
											/>
										</ImageListItem>
									))}
								</ImageList>
							</Box>
						)}
					</Box>
				</FormWrapper>

				<>
					<ScrapedEditProductDrawer
						setEditOpen={setAddProduct}
						editOpen={addProduct}
						edit={false}
						setProducts={setProducts}
						fromGroup={true}
					/>
					<UploadSheetDrawer
						setUniqueProducts={setUniqueProducts}
						setProducts={setProducts}
						group={values}
						open={sheetOpen}
						setOpen={setSheetOpen}
					/>
				</>

				{/* <Drawer
						anchor="right"
						open={addProduct}
						onClose={() => setAddProduct(false)}
					>
						<AddProductDrawer
							setEditOpen={setAddProduct}
							products={products}
							setProducts={setProducts}
							isProductOpen={addProduct}
							fromGroup={true}
							selectedCategory={category}
						/>
					</Drawer> */}

				<Dialog
					aria-labelledby="transition-modal-title"
					aria-describedby="transition-modal-description"
					open={open}
					onClose={handleClose}
					closeAfterTransition
					// BackdropComponent={Backdrop}
					// BackdropProps={{
					// 	timeout: 500,
					// }}
				>
					<DialogTitle id="alert-dialog-title">
						{"Are you sure?"}
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-description">
							Do you want to remove product
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={handleClose}>No</Button>
						<Button
							onClick={() => {
								setProducts((pre) =>
									pre.filter(({ id }) => {
										return id !== deletingProduct;
									}),
								);

								handleClose();
							}}
							autoFocus
							color="secondary"
						>
							Yes
						</Button>
					</DialogActions>
				</Dialog>
			</Box>
		</Drawer>
	);
};
